// src/pages/InviteAgent.jsx
import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import { toast } from 'react-toastify';
import { Container, Form, Button, Spinner } from 'react-bootstrap';

const ROLE_OPTIONS = [
    { value: 'agent',      label: 'Agente',        endpoint: '/auth/invite' },
    { value: 'leader',     label: 'Líder de área',  endpoint: '/auth/invite-leader' },
    { value: 'authorizer', label: 'Autorizador',    endpoint: '/auth/invite-authorizer' },
];

export default function InviteAgent() {
    const { user } = useContext(AuthContext);
    const [email,   setEmail]   = useState('');
    const [name,    setName]    = useState('');
    const [role,    setRole]    = useState('agent');
    const [loading, setLoading] = useState(false);

    const isAdmin         = user?.role === 'admin';
    const isLeaderRole    = user?.role === 'leader';
    const isAgentWithAuth = user?.role === 'agent' && user?.canAuthorize;

    if (!isAdmin && !isLeaderRole && !isAgentWithAuth) {
        return (
            <Container className="mt-4">
                <p className="text-danger">No tienes permiso para invitar usuarios.</p>
            </Container>
        );
    }

    // Los no-admin solo pueden invitar agentes
    const availableRoles = isAdmin
        ? ROLE_OPTIONS
        : ROLE_OPTIONS.filter(r => r.value === 'agent');

    const handleSubmit = async e => {
        e.preventDefault();
        if (!email.trim()) { toast.warn('El email es obligatorio'); return; }
        setLoading(true);
        try {
            const opt = ROLE_OPTIONS.find(r => r.value === role) || ROLE_OPTIONS[0];
            const res = await api.post(opt.endpoint, { email: email.trim().toLowerCase(), name: name.trim() });
            toast.success(res.data.message, { autoClose: 3000 });
            setEmail('');
            setName('');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Error al enviar invitación', { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="mt-4" style={{ maxWidth: 520 }}>
            <h4 style={{ fontWeight: 700, marginBottom: 4 }}>Invitar usuario</h4>
            <p style={{ color: 'var(--c-text-3)', fontSize: 14, marginBottom: 24 }}>
                Se enviará un correo con el enlace de registro.
            </p>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 13, fontWeight: 600 }}>Nombre completo</Form.Label>
                    <Form.Control
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Nombre del usuario"
                        style={{ borderRadius: 8 }}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 13, fontWeight: 600 }}>Correo electrónico</Form.Label>
                    <Form.Control
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="correo@ejemplo.com"
                        required
                        style={{ borderRadius: 8 }}
                    />
                </Form.Group>

                <Form.Group className="mb-4">
                    <Form.Label style={{ fontSize: 13, fontWeight: 600 }}>Rol</Form.Label>
                    <Form.Select
                        value={role}
                        onChange={e => setRole(e.target.value)}
                        style={{ borderRadius: 8 }}
                        disabled={!isAdmin && !isLeaderRole}
                    >
                        {availableRoles.map(r => (
                            <option key={r.value} value={r.value}>{r.label}</option>
                        ))}
                    </Form.Select>
                    {isLeaderRole && (
                        <Form.Text className="text-muted" style={{ fontSize: 12 }}>
                            Como líder de área solo puedes invitar agentes.
                        </Form.Text>
                    )}
                    {isAgentWithAuth && (
                        <Form.Text className="text-muted" style={{ fontSize: 12 }}>
                            Solo el administrador puede asignar otros roles.
                        </Form.Text>
                    )}
                </Form.Group>

                <Button variant="primary" type="submit" disabled={loading} style={{ borderRadius: 8, fontWeight: 600 }}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Enviar invitación'}
                </Button>
            </Form>
        </Container>
    );
}
